import { useState } from "react"
import "../Styles/SellerRegister.css"
import { PasswordInput, TextInput } from '@mantine/core';
import { toast } from "react-toastify";
import logo from "../assets/images/logo3.jpg"
import axios, { toFormData } from "axios";
import { url } from "../db/url";
import ShopVerifyOtp from "../components/shopVerifyOtp";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const SellerRegister = () => {
    const [details, setDetails] = useState({
        name: "",
        email: "",
        password: "",
        address: "",
        description: ""
    })
    const [showModal, setShowModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const handleSubmit = (e) => {
        setLoading(true)
        axios.post(`${url}/api/v2/shop/create-shop`, {...details})
        .then(res => {
            setLoading(false)
            navigate('/dashboard')
        }).catch(err => {
            toast.error(err.response? err.response.data.message : "Network Error");
            setLoading(false) 
        })
        e.preventDefault()
    }
    const handleClose = () => {
        setShowModal(false)
    }
    
    return<>
    <ShopVerifyOtp modal={showModal} onClose={handleClose} email={details['email']}  type={"seller"}/>
        <section className="seller" >
            <div className="sellerWrapper">
                <img src={logo} alt="" />
                <form action="" >
                    <div className="formHeading">
                        <h2>Create your Shop</h2>
                        <p>Create your farmcart shop account</p>
                    </div>

                    <div className="inputContainer">
                        <TextInput
                            label="Name"
                            description="Enter your full name"
                            placeholder="John Doe"
                            type="text"
                            withAsterisk
                            value={details['name']}
                            onChange={(e) => setDetails({...details, name: e.target.value})}
                        />
                        <TextInput
                            label="Email Address:"
                            description="Enter a valid email address"
                            placeholder="abc@example.com"
                            type="email"
                            withAsterisk
                            value={details['email']}
                            onChange={(e) => setDetails({...details, email: e.target.value})}
                        />
                        <PasswordInput
                            withAsterisk
                            label= "Password"
                            description="Please enter a strong password"
                            placeholder="*******"
                            value={details['password']}
                            onChange={(e) => setDetails({...details, password: e.target.value})}
                            className="passwordinput"
                        />
                        <TextInput
                            label="Address:"
                            description="Enter your shop address"
                            placeholder="Port Harcourt, Rivers State"
                            type="text"
                            withAsterisk
                            value={details['address']}
                            onChange={(e) => setDetails({...details, address: e.target.value})}
                        />
                        <TextInput
                            label="Description:"
                            description="Enter your shop description"
                            placeholder="My agrifarm e-shop"
                            type="email"
                            withAsterisk
                            value={details['description']}
                            onChange={(e) => setDetails({...details, description: e.target.value})}
                        />
                    </div>
                    <button type="submit" className="btn" onClick={handleSubmit} disabled={loading}>{loading ? "Loading..." : "Create Shop"}</button>
                </form>
            </div>
        </section>
    </>

}

export default SellerRegister